import React, { useState } from "react";
import PageWrapper from "components/PageWrapper";
import { Helmet } from "react-helmet-async";
import { machineAssets, machineParts, CollectionAssets } from "../components/Asset_handler";
import { UploadRegistration } from "api/post/email";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


function EarlyAccess() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.warn("Please enter an email address.", { position: "top-right", autoClose: 3000 });
      return;
    }

    await UploadRegistration(email);
    setEmail("");
  };
  return (
    <PageWrapper>
      <ToastContainer />
      <Helmet>
        <title>Sign up for Early Access to Updates and Launch date.</title>
        <meta name="description" content="Early Access - enter Email and that's it." />
        <meta property="og:url" content="https://www.mira-espresso.com/early_access" />
      </Helmet>
      <div className="sectionHeaderContainer newsletterSection">
        <div className="newsletterContent">
          <h1 className="newsletterHeader">Join the Revolution</h1>
          <h2 className="newsletterSubheader">Interested? Stay up to date on progress and launch date.</h2>
          <form onSubmit={handleSubmit} className="newsletterForm">
            <div className="inputGroup">
              <input type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} className="newsletterInput" />
              <button type="submit" className="newsletterButton">
                Get Early Access
              </button>
            </div>
          </form>
          <p className="disclaimer">We respect your privacy. Your email address is only used for updates regarding Mira.</p>
        </div>
      </div>
    </PageWrapper>
  );
}

export default EarlyAccess;
